export const itvStatus: { [key: number]: string } = {
  1: 'favorable',
  2: 'unfavorable',
  3: 'negative',
};
